// extracted by mini-css-extract-plugin
export default {"container":"BoxSwitch_container__GSyir","box":"BoxSwitch_box__4UBbY"};